import React from "react";

import pageData from "../config/contactPageData.json";
import StandardSizeContainer from "../customComponent/Container/StandardSizeContainer";
import HeadingTitle from "../customComponent/Title/HeadingTitle";
import CustomParagraph from "../customComponent/Title/CustomParagraph";
import TwoSectionForm from "../customComponent/TwoSections/TwoSectionForm";

const ContactPage = () => {
  const { headline,description,form } = pageData.contactSection;
  return (
    <StandardSizeContainer>
      {headline.map((item, index) => (
        <HeadingTitle key={index} text={item} />
      ))}
      <CustomParagraph text={description} />
      <TwoSectionForm data={form}/>
    </StandardSizeContainer>
  );
};

export default ContactPage;
